import { Component, OnInit } from '@angular/core';
import { AppealEventsService } from './appeal-events.service';


@Component({
  selector: 'app-appeal-events',
  standalone: false,
  templateUrl: './appeal-events.component.html',
  styleUrl: './appeal-events.component.scss'
})
export class AppealEventsComponent implements OnInit {
  appealEvents: any[] = [];
  loading: boolean = true;
  allAppealEvents: any[] = [];
  fromEventDate: string | null = null;   // yyyy-MM-dd
  toEventDate: string | null = null;     // yyyy-MM-dd

  constructor(
    private appealEventsService: AppealEventsService
  ) { }

  ngOnInit(): void {
    this.loadAppealEvents();
  }

  loadAppealEvents(): void {
    this.loading = true;
    this.appealEventsService.getAllAppealEvents().subscribe({
      next: (response) => {
        // response structure:
        // { count: number, data: [ {...}, {...} ] }
        if (response && response.data) {
          const mapped = response.data.map((item: any) => {
            return {
              caseNumber: item['Case Number'],
              appealCaseNumber: item['Appeal Case Number'],
              nda: item['NDA'],
              brand: item['Brand'],
              plaintiff: item['Plaintiff'],
              defendant: item['Defendant'],
              courtName: item['Court Name'],
              appealCourt: item['Appeal Court'],
              appellant: item['Appellant'],
              appealStatus: item['Appeal Status'],
              eventName: item['Event Name'],
              eventDate: item['Event Date']
            };
          });

          // Store master + current filtered list
          this.allAppealEvents = mapped;
          this.appealEvents = [...mapped];
        } else {
          this.allAppealEvents = [];
          this.appealEvents = [];
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading appeal events', err);
        this.allAppealEvents = [];
        this.appealEvents = [];
        this.loading = false;
      }
    });
  }

  onApplyEventDateFilter(): void {
    if (!this.fromEventDate && !this.toEventDate) {
      // No filter selected, reset to full list
      this.appealEvents = [...this.allAppealEvents];
      return;
    }

    const from = this.fromEventDate ? new Date(this.fromEventDate) : null;
    const to = this.toEventDate ? new Date(this.toEventDate) : null;

    if (from) {
      from.setHours(0, 0, 0, 0);
    }
    if (to) {
      to.setHours(0, 0, 0, 0);
    }

    this.appealEvents = this.allAppealEvents.filter(row => {
      if (!row.eventDate) {
        return false;
      }

      const cellDate = new Date(row.eventDate);
      if (isNaN(cellDate.getTime())) {
        return false;
      }

      cellDate.setHours(0, 0, 0, 0);

      if (from && cellDate < from) {
        return false;
      }
      if (to && cellDate > to) {
        return false;
      }

      return true;
    });
  }

  // 🔄 Clear date filter
  onClearEventDateFilter(): void {
    this.fromEventDate = null;
    this.toEventDate = null;
    this.appealEvents = [...this.allAppealEvents];
  }
}
